import React from "react";
import InputItem from './InputItem'
import MoneyInputCon from '$Deposits/Components/Components/MoneyInput'

class MoneyInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {


        return (
            <>
                <MoneyInputCon
                    MoneyInput={(propCon) => {
                        const {
                            type,
                            title,
                            stateVal,
                            value,
                            placeholder,
                            onChange,
                        } = propCon
                        return (
                            <InputItem
                                type={type}
                                title={title}
                                stateVal={stateVal}
                                value={value}
                                placeholder={placeholder}
                                onChange={onChange}
                            />
                        )
                    }}
                />
            </>
        );
    }
}

export default MoneyInput


